export default {
  documentos: [],
  filtros: {
    perPage: 20,
    page: 1,
    periodo: [],
    campoData: [],
    termo: '',
    referenciaInterna: '',
    referenciaCliente: '',
    order: 'codigoProcesso',
    direcao: '',
  },
  campos: {
    statusProcesso: 'statusProcesso',
    referenciaInterna: 'referenciaInterna',
    referenciaCliente: 'referenciaCliente',
  },
  colDefault: '',
  directionDefault: '',
  filterDefs: {
    referenciaInterna: {
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        moduleFiltros: 'ged',
        fetch: 'fetchAllArquivosProcessos',
        colDef: {
          field: 'referenciaInterna',
        },
      },
    },
    referenciaCliente: {
      filter: 'TextFilter',
      filterParams: {
        module: 'Processes',
        moduleFiltros: 'ged',
        fetch: 'fetchAllArquivosProcessos',
        colDef: {
          field: 'referenciaCliente',
        },
      },
    },
  },
  // Sortable false para desabilitar o sort local do vuetify
  tableColumns: [
    {
      text: 'status',
      value: 'statusProcesso',
      sortable: false,
      filterable: false,
    },
    {
      text: 'referenciaCliente',
      value: 'referenciaInterna',
      sortable: false,
      filterable: false,
    },
    {
      text: 'referenciaTrust',
      value: 'referenciaCliente',
      sortable: false,
      filterable: false,
    },
    {
      text: 'acoes',
      value: 'acoes',
      sortable: false,
      filterable: false,
      width: 106,
    },
  ],
  documentosOriginaisHeader: [
    {
      text: 'situacao',
      value: 'situacao',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'situacao',
      },
    },
    {
      text: 'data',
      value: 'data',
      filterable: true,
      filterComponent: 'DateFilter',
      isDataTable: true,
      filterParams: {
        field: 'data',
      },
    },
    {
      text: 'local',
      value: 'local',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        field: 'local',
      },
    },
  ],
  documentosOriginaisItens: [],
  documentosOriginaisFiltros: {
    perPage: 20,
    page: 1,
    processo: '',
    situacao: '',
    data: '',
    local: '',
  },
};
